<template>
  <v-card>
    <v-toolbar color="secondary lighten-2" dark tabs>
      <v-toolbar-title>{{ $t('measure_widget_label') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn flat icon color="accent" @click="$router.push('/measures')">
        <v-icon>open_in_new</v-icon>
      </v-btn>

      <!--<v-tabs
                slot="extension"
                v-model="tab"
                centered
                grow
                color="secondary lighten-2"
            >
                <v-tabs-slider color="yellow"></v-tabs-slider>

                <v-tab 
                    v-for="(tab,tab_id) in tabs"
                    :key="tab_id">
                    {{ tab.text }}
                </v-tab>

      </v-tabs>-->
    </v-toolbar>

    <!--<v-tabs-items v-model="tab">

            <v-tab-item
                v-for="(tab, tab_id) in tabs"
                :key="tab_id"
    >-->

    <v-card flat>
      <v-card-text>
        <v-list three-line subheader>
          <!--<v-subheader inset>Overdue</v-subheader>-->

          <v-list-tile
            v-for="(item, item_id) in currentMeasures"
            :key="item_id"
            avatar
            @click="updateCurrentMeasure(item.audit_id, item.audititem_id, item.deviation_id, item.id, item)"
          >
            <!--<v-list-tile-avatar>
                                <v-icon v-if="item.priority" :class="[item.iconClass]">!</v-icon>
                                <v-icon v-else :class="[item.iconClass]"></v-icon>
            </v-list-tile-avatar>-->

            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ item.audit_name }}
                <br />
                {{ $t('measure_widget_due_date') }}
                <SnippetDate format="chips" :items="item.dueDate" />
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-chip ripple color="primary" outline>
                <SnippetWorkflow :status="item.status" workflow-name="measure" />
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>

    <!-- </v-tab-item>

            <v-tab-item>

                <v-card flat>
                    <v-card-text>

                        Tab Item 2
                        
                    </v-card-text>
                </v-card>

            </v-tab-item>

    </v-tabs-items>-->
  </v-card>
</template>

<i18n>
    {
        "de": {
            "measure_widget_label" : "Maßnahmen",
            "measure_widget_mymeasures" : "Meine Aufgaben",
            "measure_widget_allmeasures" : "Relevante Aufgaben",
            "measure_widget_due_date" : "Zu erledigen bis: "
        },
        "en": {
            "measure_widget_label" : "My Measures",
            "measure_widget_due_date" : "Due date: "
        }
    }
</i18n>

<script>
import moment from "moment";
import SnippetWorkflow from "@/components/snippets/SnippetWorkflow.vue";
import SnippetDate from "@/components/snippets/SnippetDate.vue";

import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/audits";

export default {
  components: {
    SnippetWorkflow,
    SnippetDate
  },
  data() {
    return {
      boxes: [
        { id: "today", description: "Today" },
        { id: "tomorrow", description: "Tomorrow" },
        { id: "nextweek", description: "Next Week" },
        { id: "nextmonth", description: "Next Month" }
      ],
      tab: null,
      tabs: [
        {
          text: this.$i18n.t("measure_widget_mymeasures"),
          query: "my"
        },
        {
          text: this.$i18n.t("measure_widget_allmeasures"),
          query: "all"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.getTodos,
      api.getters.getFinalMeasureWorkflowStatusId
    ]),
    currentMeasures() {
      console.log("currentMeasures", this.getFinalMeasureWorkflowStatusId);
      let user_id = this.$user.id();
      let count = 10;

      const filterset = {
        include: {
          assignedTo: user_id
        },
        exclude: {
          status: [this.getFinalMeasureWorkflowStatusId]
        }
      };

      console.log("Meine UID", user_id);

      return this.getTodos(filterset.include, filterset.exclude, count);
    },
    filter(items, query /*, sort*/) {
      return items.filter(function(item) {
        let now = moment();
        let today = now.clone().startOf("day");
        let yesterday = now
          .clone()
          .add(-1, "days")
          .startOf("day");

        let lastweek = now
          .clone()
          .add(-7, "days")
          .startOf("day");
        let momentDate = moment(item.auditing_date);

        if (query === "today") {
          if (momentDate.isSame(today, "d")) {
            return item;
          }
        } else if (query === "tomorrow") {
          if (momentDate.isSame(yesterday, "d")) {
            return item;
          }
        } else if (query === "nextweek") {
          if (
            momentDate.isAfter(lastweek, "d") &&
            momentDate.isBefore(yesterday, "d")
          ) {
            return item;
          }
        } else if (query === "nextmonth") {
          if (momentDate.isBefore(lastweek, "d")) {
            return item;
          }
        } else {
          return item;
        }
      });
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.setAuditId,
      api.actions.setAuditItemId,
      api.actions.setDeviationId,
      api.actions.setMeasureId,
      api.actions.setDialogItem,
      api.actions.setDialogAction
    ]),
    updateCurrentMeasure(
      audit_id,
      audititem_id,
      deviation_id,
      measure_id,
      measure
    ) {
      console.log(
        "Setting Object Path",
        audit_id,
        audititem_id,
        deviation_id,
        measure_id
      );

      this.setAuditId(audit_id);
      this.setAuditItemId(audititem_id);
      this.setDeviationId(deviation_id);
      this.setMeasureId(measure_id);
      this.setDialogItem({ ...measure });
      this.setDialogAction("update");

      //TODO: So ist das noch nicht persistent!

      console.log("Update Measure");
      this.$router.push({ name: "measuredialog", params: { id: measure_id } });
    }
  }
};
</script>
